import { RootState } from "../store";
import cognitoService from '../../cognito';

export const getCognitoIdToken = async () => {
  let session = cognitoService.getCurrentSession();
  if (!session) {
    throw new Error('No session found');
  }

  if (!session.isValid()) {
    session = await cognitoService.refreshCurrentSession();
    if (!session) {
      throw new Error('Failed to refresh session');
    }
  }

  return session.getIdToken().getJwtToken();
}

export const getAccessToken = async (getState: () => RootState) => {
  const state = getState();
  const { logInMethod, accessToken } = state.auth;

  switch (logInMethod) {
    case 'OKTA':
      return accessToken;
    case 'COGNITO':
      return await getCognitoIdToken();
    default:
      throw new Error(`Invalid logInMethod: ${logInMethod}`);
  }
};

export const appendFilterParams = <T extends object>(url: URL, filterParams: T | undefined) => {
  Object.entries(filterParams || {}).forEach(([k, v]) => {
    if (v !== null && v !== undefined) {
      if (Array.isArray(v)) {
        v.forEach((arrayVal) => {
          if (arrayVal !== null && arrayVal !== undefined) {
            url.searchParams.append(`${k}[]`, arrayVal.toString());
          }
        });
      } else {
        url.searchParams.append(k, v.toString());
      }
    }
  });
}

export const exportResource = async (url: URL, params: Record<string, string | readonly string[] | number | boolean | undefined>, accessToken: string | undefined): Promise<Blob> => {
  appendFilterParams(url, params);

  const response = await fetch(url.href, {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return await response.blob();
}